export default __webpack_public_path__ + "static/media/Newsletter 009.35bf283c.png";